import { render } from "./ServicesPage.vue?vue&type=template&id=e1f0310e&scoped=true"
import script from "./ServicesPage.vue?vue&type=script&lang=js"
export * from "./ServicesPage.vue?vue&type=script&lang=js"

import "./ServicesPage.vue?vue&type=style&index=0&id=e1f0310e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1f0310e"]])

export default __exports__